import { render, staticRenderFns } from "./CModal.vue?vue&type=template&id=715023e6&"
import script from "./CModal.vue?vue&type=script&lang=js&"
export * from "./CModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports